import React from 'react';
import urls from 'Source/urls';
import { Box, Card, IconButton, Popover, PopoverContent, PopoverTrigger } from 'pounceV2';
import { PANTHER_DOCS_LINK } from 'Source/constants';
import NavLinkV3 from 'Components/Navigation/NavLink/NavLinkV3';
import NavLinkExternalV3 from 'Components/Navigation/NavLink/NavLinkExternalV3';
import { useTheme } from '@mui/material';

const HelpMenuV3: React.FC = () => {
  const theme = useTheme();

  return (
    <Popover>
      {({ close: closePopover }) => (
        <React.Fragment>
          <Box>
            <PopoverTrigger
              as={IconButton}
              id="help-menu"
              icon="help-alt"
              variant="ghost"
              data-tid="help-menu-dropdown-button"
              aria-label="Toggle Help Menu"
            />
          </Box>
          <PopoverContent alignment="bottom-left">
            <Card
              as="ul"
              p={1.5}
              border={`1px solid ${theme.palette.componentTokens.selectMenuItems.color.item.stroke.container.resting}`}
              backgroundColor={
                theme.palette.componentTokens.selectMenuItems.color.item.background.containerBase
              }
              minWidth={180}
            >
              <Box as="li">
                <NavLinkV3
                  label="Support"
                  to={urls.account.support()}
                  isSecondary
                  onClick={closePopover}
                />
              </Box>
              <Box as="li" mt="auto">
                <NavLinkExternalV3
                  label="Documentation"
                  href={PANTHER_DOCS_LINK}
                  isSecondary
                  onClick={closePopover}
                />
              </Box>
            </Card>
          </PopoverContent>
        </React.Fragment>
      )}
    </Popover>
  );
};

export default React.memo(HelpMenuV3);
